module.exports = __webpack_public_path__ + "static/media/check_box_icon.7c23579f.svg";